module.exports = __webpack_public_path__ + "static/media/shoe (20).07f6733f.jpg";